import { render, staticRenderFns } from "./ActiveOrderListItem.vue?vue&type=template&id=3c13ba85&"
import script from "./ActiveOrderListItem.vue?vue&type=script&lang=ts&"
export * from "./ActiveOrderListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports